// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  ICheckPaymentByProviderRequest,
  TCheckPaymentByProviderModel,
  IMappers,
  TCheckPaymentByProviderResponse,
  ICheckPaymentByProviderResponse,
} from './types';

export const defaultConfig: TCheckPaymentByProviderModel = {
  apiType: 'public',
  assertStatusCodes: [200],
  hostType: 'api',
  method: 'GET',
  microserviceName: 'billing-payments',
  pathApi: '/v1/check-payment-by-provider/',
  responseType: 'json',
} as TCheckPaymentByProviderModel;

export function createCheckPaymentByProviderModel(
  parameters: ICheckPaymentByProviderRequest,
): TCheckPaymentByProviderModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface ICheckPaymentByProviderOptions<TResponse200> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200>;
  parameters: ICheckPaymentByProviderRequest;
}

export async function fetchCheckPaymentByProvider<TResponse200>({
  httpApi,
  config,
  mappers,
  parameters,
}: ICheckPaymentByProviderOptions<TResponse200>): Promise<TCheckPaymentByProviderResponse | TResponse200> {
  const { statusCode, response, headers } = await httpApi.fetch(createCheckPaymentByProviderModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ICheckPaymentByProviderResponse);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TCheckPaymentByProviderResponse;
}
